var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTwitterIcon = function SvgTwitterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.039a6.564 6.564 0 0 1-1.885.517A3.292 3.292 0 0 0 15.558.74a6.576 6.576 0 0 1-2.085.796A3.282 3.282 0 0 0 7.88 4.53a9.32 9.32 0 0 1-6.765-3.428A3.28 3.28 0 0 0 2.13 5.483a3.27 3.27 0 0 1-1.487-.411v.041a3.284 3.284 0 0 0 2.633 3.218 3.288 3.288 0 0 1-1.483.056 3.286 3.286 0 0 0 3.067 2.28A6.587 6.587 0 0 1 0 12.025 9.293 9.293 0 0 0 5.032 13.5c6.038 0 9.34-5 9.34-9.338 0-.142-.004-.283-.01-.424A6.671 6.671 0 0 0 16 2.038Z",
    fill: "#55ACEE"
  })));
};

export default SvgTwitterIcon;